import { ConfigurationWithPaymentData } from 'components/features/Configuration/types';
import { fetchWrapper, RequestMethod } from 'helpers';

export const getConfigForPayment =
	(clientId: string, entity: string) => async (): Promise<ConfigurationWithPaymentData> =>
		fetchWrapper<ConfigurationWithPaymentData>(`/payments/config?clientId=${clientId}&entity=${entity}`, {
			method: RequestMethod.GET,
		});
